import React from 'react'
import { Content, Projects, Experience } from '../../../components/home'
import './Storyboard.css'
const GitHub = () => {
    return (      
        <div className="story__section">
            <Projects />
        </div>
    )
}

const Storyboard = () => {
    return (
        <div className="story">
            <Content />            
            <Experience />
            <GitHub />
        </div>
    )
}

export default Storyboard
